import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MdWarning, MdCheckCircle } from 'react-icons/md';

import { openValidationModal } from '~/store/modules/pickupValidation/actions';
import {
  AlertBanner,
  AlertBannerSuccess,
  AlertContent,
  AlertButton,
  AlertButtonSuccess,
} from './styles';

const ALERT_STATUSES = ['GOING_TO_STORE', 'ARRIVED_AT_STORE'];

// Status em que o operador ainda precisa agir (validar ou re-validar)
const ACTIONABLE_VALIDATION_STATUSES = ['pending', 'failed', 'blocked'];

// Status em que a validação foi concluída mas ainda faz sentido informar
// o operador via alerta (motoboy ainda não acionou coleta)
const VALIDATED_WAITING_STATUSES = ['awaiting_dispatch'];

export default function PickupValidationAlert({
  deliveryStatus = '',
  featureEnabled = false,
  cartValidation = null,
  cartId = null,
}) {
  const dispatch = useDispatch();
  const reduxValidation = useSelector(
    state => state.pickupValidation.validation
  );

  const reduxBelongsToThisCart =
    reduxValidation &&
    cartId &&
    String(reduxValidation.cart_id) === String(cartId);

  const effectiveValidation = reduxBelongsToThisCart
    ? reduxValidation
    : cartValidation;

  const handleOpen = useCallback(() => {
    dispatch(openValidationModal());
  }, [dispatch]);

  if (!featureEnabled || !ALERT_STATUSES.includes(deliveryStatus)) {
    return null;
  }

  const status = effectiveValidation?.status;
  const isActionable =
    !effectiveValidation || ACTIONABLE_VALIDATION_STATUSES.includes(status);
  const isValidatedWaiting = VALIDATED_WAITING_STATUSES.includes(status);

  // Estado 3: sessão já saiu dos estados relevantes pra alerta (dispatched, released, etc)
  if (!isActionable && !isValidatedWaiting) {
    return null;
  }

  // Estado 2: validado, aguardando entregador acionar coleta
  if (isValidatedWaiting) {
    return (
      <AlertBannerSuccess>
        <MdCheckCircle size={28} />
        <AlertContent>
          <strong>Entregador validado</strong>
          <span>
            Aguardando entregador acionar a coleta no app do parceiro.
          </span>
        </AlertContent>
        <AlertButtonSuccess
          type="button"
          onClick={handleOpen}
          variant="secondary"
        >
          Ver status
        </AlertButtonSuccess>
      </AlertBannerSuccess>
    );
  }

  // Estado 1: ação pendente
  // Estado 1: ação pendente
  const isBlocked = status === 'blocked';
  const isArrived = deliveryStatus === 'ARRIVED_AT_STORE';

  let title;
  let subtitle;

  if (isBlocked) {
    title = 'Coleta bloqueada';
    subtitle =
      'Não entregue a mercadoria. Acione o suporte Viddy para verificar o entregador.';
  } else {
    title = isArrived
      ? 'Não entregue o pedido ainda!'
      : 'Um entregador está a caminho.';
    subtitle = isArrived
      ? 'Confira os dados do entregador antes de liberar a mercadoria.'
      : 'Confira os dados do entregador antes que ele chegue à loja.';
  }

  return (
    <AlertBanner>
      <MdWarning size={28} />
      <AlertContent>
        <strong>{title}</strong>
        <span>{subtitle}</span>
      </AlertContent>
      <AlertButton type="button" onClick={handleOpen}>
        {isBlocked ? 'Ver orientação' : 'Conferir entregador'}
      </AlertButton>
    </AlertBanner>
  );
}
